import sendRequirements from './sendRequirements'
import rejectCP from './rejectCP'

export {
  sendRequirements,
  rejectCP,
}



// WEBPACK FOOTER //
// ./src/services/sinister/closeProject/index.js